// extracted by mini-css-extract-plugin
export var container = "_7n-0";
export var fallback = "_7n-5";
export var fallbackIcon = "_7n-6";
export var hidden = "_7n-2";
export var image = "_7n-3";
export var loaded = "_7n-4";
export var placeholder = "_7n-1";